import React from 'react';

const ProjectTypeFilter = ({ searchData, filterData }) => {
  return (
    <div className="inline-flex items-center px-2 py-3 border border-gray-100 rounded-md bg-white">
      <button
        className={`px-4 py-1 ${
          filterData.investmentType === ''
            ? 'bg-brandBlue text-white'
            : 'bg-white text-brandBlue'
        }`}
        onClick={() => searchData('investmentType', '')}
      >
        All
      </button>
      <button
        className={`px-4 py-1 ${
          filterData.investmentType === 'asset'
            ? 'bg-brandBlue text-white'
            : 'bg-white text-brandBlue'
        }`}
        onClick={() => searchData('investmentType', 'asset')}
      >
        Equity
      </button>
      <button
        className={`px-4 py-1 ${
          filterData.investmentType === 'bond'
            ? 'bg-brandBlue text-white'
            : 'bg-white text-brandBlue'
        }`}
        onClick={() => searchData('investmentType', 'bond')}
      >
        Bonds
      </button>
    </div>
  );
};

export default ProjectTypeFilter;
